import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBoards, createBoard } from '../store/boardSlice';

/**
 * Hook para gerenciar a lista de boards.
 * Ideal para páginas de listagem e criação de boards.
 *
 * @param {boolean} autoFetch - Se true, busca os boards automaticamente ao montar. Default: true
 *
 * @example
 * const { boards, isLoading, error, loadBoards, addBoard } = useBoards();
 */
const useBoards = (autoFetch = true) => {
  const dispatch = useDispatch();

  // Selectors
  const boards = useSelector((state) => state.board.list);
  const isLoading = useSelector((state) => state.board.loading);
  const error = useSelector((state) => state.board.error);

  // Busca todos os boards
  const loadBoards = useCallback(() => {
    dispatch(fetchBoards());
  }, [dispatch]);

  // Cria um novo board pelo nome
  const addBoard = useCallback(
    (boardName) => {
      if (!boardName?.trim()) return;
      dispatch(createBoard(boardName));
    },
    [dispatch]
  );

  // Busca os boards automaticamente ao montar o componente
  useEffect(() => {
    if (autoFetch) {
      loadBoards();
    }
  }, [autoFetch, loadBoards]);

  return {
    // Estado
    boards,
    isLoading,
    error,

    // Ações
    loadBoards,
    addBoard,
  };
};

export default useBoards;